import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sort'
})
export class SortPipe implements PipeTransform {
	
	transform(ary: any, fn: Function = (a,b) => a > b ? 1 : -1): any {
		return ary ? ary.sort(fn) : [];
	}

}



// WEBPACK FOOTER //
// ./src/app/global/_pipes/sort.pipe.ts